// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4p-5";
export var imageContainer = "_4p-4";
export var metricsGrid = "_4p-2";
export var productDetailContainer = "_4p-1";
export var productListContainer = "_4p-0";
export var subscriberTableContainer = "_4p-3";